import { useMemo } from 'react';
import { getIdToken } from '@/lib/auth-state';
import { getEnv } from '@/lib/env';
import { type ApiClient, createApiClient } from './client';

/**
 * Returns an auth-aware API client. `getIdToken` is async — the middleware
 * already supports `Promise<string | undefined>`, so the id token is fetched
 * (and silently refreshed by Amplify) on every request.
 *
 * The client itself has no auth dependency, so a single memoised instance is
 * reused for the lifetime of the app.
 */
export function useApiClient(): ApiClient {
  return useMemo(
    () =>
      createApiClient({
        baseUrl: getEnv().VITE_API_BASE_URL,
        getAccessToken: () => getIdToken(),
      }),
    [],
  );
}
